import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function RefundPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
                <Helmet>
                <title>Refund policy - Equibre</title>
                <meta name="description" content="Our refund or cancellation regarding terms." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Refund policy</h1>
                    <p>Last updated: 9 June 2024</p>
                </div>
            </section>
            <section className="privacy-section">
                <div className="inner">
                    <div className="content">
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">1. Introduction</h3>
                        <p className="mb-4">
                            At Equibre, we strive to ensure complete satisfaction with our
                            products and services. This Refund Policy outlines the terms and
                            conditions under which refunds may be issued.
                        </p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">2. Eligibility of refunds</h3>
                        <p className="mb-4">Refund requests for services must be made within 7 days of the initial service date. Services rendered beyond this period are not eligible for a refund.</p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">3. How to request refund?</h3>
                        <p className="mb-4">You can reach us at our communication channels by sending email at <a className="normal-link" href="mailto:support@equibre.com">support@equibre.com</a> or call us at <a className="normal-link" href="tel:918757714590">+91 (875) 771 4590</a>.</p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">4. Processing of refunds</h3>
                        <p className="mb-4">Once we recieve your query, we will notify you of the approval of it and after approval your refund will be issued in under 7 working days.</p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">5. Changes to this policy</h3>
                        <p className="mb-4">We reserve the right to modify this Refund Policy at any time. Changes will be posted on this page, and the effective date will be updated.</p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">6. Governing law</h3>
                        <p className="mb-4">This Refund Policy shall be governed by and construed in accordance with the laws of India.</p>
                        <h3 className="h4 mb-8 text-primary" data-aos="fade-up">7. Contact Us</h3>
                        <p className="mb-4">
                            If you have any questions or concerns about these Terms, please contact us at{" "}
                            <a href="mailto:support@equibre.com" className="normal-link">
                                support@equibre.com
                            </a>
                            .
                        </p>
                        <div style={{ width: '100%', height: 80 }}></div>
                    </div>
                </div>
            </section>
            <ContactListSection />
        </>
    );
}